import posthog from 'posthog-js'
import { useCallback } from 'react'
import { type ToggleFavoritePlotGroupActionData } from '#app/routes/resources+/plot.toggle-favorite-group'
import { useStoreContext } from '#app/store'
import { useFetcherWithPromise } from './use-fetcher-with-promise'

export const useToggleFavoritePlotGroup = () => {
	const addFavoritePlotGroupId = useStoreContext(s => s.addFavoritePlotGroupId)
	const removeFavoritePlotGroupId = useStoreContext(
		s => s.removeFavoritePlotGroupId,
	)

	const fetcher = useFetcherWithPromise<ToggleFavoritePlotGroupActionData>()

	const toggleFavoritePlotGroup = useCallback(
		async (groupId: string) => {
			const formData = new FormData()
			formData.append('groupId', JSON.stringify(groupId))

			const res = await fetcher.submit(formData, {
				method: 'POST',
				action: '/resources/plot/toggle-favorite-group',
			})

			const isFavorite = res?.isFavorite

			if (isFavorite) {
				addFavoritePlotGroupId(groupId)
				posthog.capture('plot_add_favorite', { groupId })
			} else {
				removeFavoritePlotGroupId(groupId)
				posthog.capture('plot_remove_favorite', { groupId })
			}

			return isFavorite
		},
		[fetcher, removeFavoritePlotGroupId, addFavoritePlotGroupId],
	)

	return toggleFavoritePlotGroup
}
